// extracted by mini-css-extract-plugin
module.exports = {"header":"Bar__header--sB","body":"Bar__body--mi","failedLine":"Bar__failedLine--g6","failed":"Bar__failed--tX","column":"Bar__column--jN"};